import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Live.module.css';

// Red pulsing "LIVE" pill; a grey "Færdig" pill once the map is over but still in the feed.
const LiveBadge: React.FC<{ finished?: boolean }> = ({ finished = false }) => {
    const { t } = useTranslation('pages');
    return finished
        ? <span className={`${styles.liveBadge} ${styles.finishedBadge}`}>{t('live.finished')}</span>
        : <span className={styles.liveBadge}><span className={styles.liveDot} />{t('live.live')}</span>;
};

export default LiveBadge;
